import { Link } from 'react-router-dom';
import { Navbar } from '@/components/landing/Navbar';
import { Footer } from '@/components/landing/Footer';
import { getAllPosts } from '@/lib/blog';
import { useEffect } from 'react';

export default function Blog() {
  const posts = getAllPosts();

  useEffect(() => {
    document.title = 'Blog — RadiologyLive.ai';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Thoughts on AI, radiology, and the future of diagnostic imaging.');
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold tracking-tight text-foreground mb-2">Blog</h1>
          <p className="text-muted-foreground mb-12">Thoughts on AI, radiology, and the future of diagnostic imaging.</p>

          <div className="space-y-10">
            {posts.map((post) => (
              <article key={post.slug} className="group">
                <Link to={`/blog/${post.slug}`} className="block">
                  <time className="text-sm text-muted-foreground">
                    {new Date(post.date + 'T00:00:00').toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                    {' · '}{post.readingTime} min read
                  </time>
                  <h2 className="text-xl font-semibold text-foreground mt-1 group-hover:text-primary transition-colors">
                    {post.title}
                  </h2>
                  {post.subtitle && (
                    <p className="text-muted-foreground mt-1">{post.subtitle}</p>
                  )}
                </Link>
              </article>
            ))}
          </div>

          {posts.length === 0 && (
            <p className="text-muted-foreground">No posts yet. Check back soon.</p>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
